import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'

import {
  Grid,
  Paper,
  Avatar,
  Typography,
  CircularProgress,
  Button,
  Box
} from '@mui/material'

import { database } from 'config/firebase';

const Projects = () => {

  const navigate = useNavigate()

  const [projects, setProjects] = useState<any[] | null>(null)

  async function getProjects() {
    const { docs } = await database.collection('projects').get()

    const data = docs.map(doc => {
      return {
        id: doc.id,
        ...doc.data()
      }
    }) as any[]

    setProjects(data)
  }

  function handleCreateProject() {
    
  }

  useEffect(() => {
    getProjects()
  }, [])

  if (!projects) {
    return <CircularProgress color="primary" />
  }

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}
    >
      <Button
        onClick={handleCreateProject}
        variant="contained"
        sx={{ ml: 1 }}
      >
        Criar projeto
      </Button>
      <Grid container>

        {
          projects.map(project => (
            <Grid
              item
              xs={12}
              md={2}
            >
              <Paper
                key={project.id}
                elevation={3}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  p: 3,
                  m: 1
                }}
                onClick={() => navigate(`/project/${project.id}`)}
              >
                <Avatar
                  alt={`image of project ${project.name}`}
                  src={project.image}
                  sx={{
                    width: 96,
                    height: 96,
                    mb: 2
                  }}
                />
                <Typography variant="body1">{project.name}</Typography>
              </Paper>
            </Grid>
          ))
        }
      </Grid>
    </Box>
  )
}

export default Projects